var _excluded = ["children", "className", "description", "heading", "primaryAction", "secondaryAction", "size"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import styled from 'styled-components';
import { Sizes } from "../../../constants.js";
import Layout from "../../basic/Layout/Layout.js";
import BodyText from "../../type/BodyText.js";
import { HEADING_SIZES } from "../../type/constants.js";
import Heading from "../../type/Heading.js";
import Button from "../Button/Button.js";
var StyledContainer = styled(Layout).withConfig({
  componentId: "CL__sc-nebn36-0"
})(["max-width:444px;margin:0 auto;text-align:center;"]);
var StyledHeading = styled(Heading).withConfig({
  componentId: "CL__sc-nebn36-1"
})(["margin:0;"]);
var StyledDescription = styled(BodyText).withConfig({
  componentId: "CL__sc-nebn36-2"
})(["margin:0;"]);
var getHeadingSize = size => {
  if (size === Sizes.SMALL) {
    return HEADING_SIZES.XX_SMALL;
  }
  if (size === Sizes.LARGE) {
    return HEADING_SIZES.MEDIUM;
  }
  return HEADING_SIZES.SMALL;
};
var getLayoutGap = size => {
  if (size === HEADING_SIZES.SMALL) {
    return 'var(--spacing-2)';
  }
  if (size === HEADING_SIZES.LARGE) {
    return 'var(--spacing-4)';
  }
  return 'var(--spacing-3)';
};
var EmptyState = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
      children,
      className,
      description,
      heading,
      primaryAction,
      secondaryAction,
      size = Sizes.MEDIUM
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledContainer, _extends({
    align: "center",
    className: className,
    gap: getLayoutGap(size),
    ref: ref,
    vertical: true
  }, props), heading && /*#__PURE__*/React.createElement(StyledHeading, {
    forwardedAs: "h3",
    size: getHeadingSize(size)
  }, heading), description && /*#__PURE__*/React.createElement(StyledDescription, {
    size: size
  }, description), (children || primaryAction || secondaryAction) && /*#__PURE__*/React.createElement(Layout, null, children, !children && secondaryAction && /*#__PURE__*/React.createElement(Button, _extends({}, secondaryAction, {
    size: size,
    variant: "text"
  }), secondaryAction.text), !children && primaryAction && /*#__PURE__*/React.createElement(Button, _extends({}, primaryAction, {
    size: size,
    variant: "primary"
  }), primaryAction.text)));
});
export default EmptyState;